import { useEffect } from "react"
import Value from "aldoo-ra/Value"

const PlatformUrlManager = () => {
  const [sitePlatform] = Value("site_platform")

  useEffect(() => {
    if (!sitePlatform) return

    const currentPath = window.location.pathname

    // Redirect generic routes to platform-specific routes
    if (currentPath === "/") {
      window.history.replaceState(null, "", `/${sitePlatform}`)
    } else if (currentPath === "/features") {
      window.history.replaceState(null, "", `/${sitePlatform}/features`)
    }
  }, [sitePlatform])

  return null
}

export default PlatformUrlManager